window.HealthyEatingGtm = ({
    memberNumber: {
        overMaxLength: function () {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.validate,
                validation: window.HealthyEatingConstants.gtm.event.error,
                validationReason: window.HealthyEatingConstants.gtm.event.long
            });
        },
        tooShort: function () {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.validate,
                validation: window.HealthyEatingConstants.gtm.event.error,
                validationReason: window.HealthyEatingConstants.gtm.event.short
            });
        },
        wrongNumber: function () {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.validate,
                validation: window.HealthyEatingConstants.gtm.event.error,
                validationReason: window.HealthyEatingConstants.gtm.event.incorrect
            });
        }
    },
    delink: {
        success: function () {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.delink,
                action: window.HealthyEatingConstants.gtm.event.delinkAcc,
                delinkResult: window.HealthyEatingConstants.gtm.event.successful,
                partner: window.HealthyEatingConstants.gtm.event.partnerName
            });
        },
        successFail: function (data) {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.delink,
                action: window.HealthyEatingConstants.gtm.event.delinkAcc,
                delinkResult: window.HealthyEatingConstants.gtm.event.failure,
                errorMessage: 'Error code: ' + data.ErrorCode +
                    '. Error description: ' + data.ErrorTitle,
                partner: window.HealthyEatingConstants.gtm.event.partnerName
            });
        },
        error: function (jqXHR, textStatus) {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.delink,
                section: window.HealthyEatingConstants.gtm.event.techError,
                errorMessage: 'Status code: ' + jqXHR.status +
                    ' Status text: ' + jqXHR.statusText +
                    ' Response text: ' + jqXHR.responseText +
                    ' Text status: ' + textStatus
            });
        }
    },
    stepOne: {
       submit: function () {
           window.dataLayer.push({
               event: window.HealthyEatingConstants.gtm.event.continue,
               section: window.HealthyEatingConstants.gtm.event.review
           });
       }
    },
    stepTwo: {
        confirmDetails: {
            cancel: function () {
                window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.continue,
                    section: window.HealthyEatingConstants.gtm.event.cancelReview
                });
            },
            confirm: function () {
                window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.continue,
                    section: window.HealthyEatingConstants.gtm.event.confirmation
                });
            }
        },
        submit: function () {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.continue,
                section: window.HealthyEatingConstants.gtm.event.detailsModal
            });
        }
    },
    stepThree: {
        submit: function () {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.validate,
                validation: window.HealthyEatingConstants.gtm.event.error,
                validationReason: window.HealthyEatingConstants.gtm.event.termsAndData
            });
        },
        success: function () {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.continue,
                section: window.HealthyEatingConstants.gtm.event.complete
            });
        },
        successError: function (data) {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.continue,
                section: window.HealthyEatingConstants.gtm.event.accountError,
                errorMessage:
                    'Error code: ' + data.ErrorCode
            });
        },
        error: function (jqXHR, textStatus) {
            window.dataLayer.push({
                event: window.HealthyEatingConstants.gtm.event.continue,
                section: window.HealthyEatingConstants.gtm.event.techError,
                errorMessage: 'Status code: ' + jqXHR.status +
                    ' Status text: ' + jqXHR.statusText +
                    ' Response text: ' + jqXHR.responseText +
                    ' Text status: ' + textStatus
            });
        }
    },
    gtm: function () {
        $(window.HealthyEatingConstants.elements.buttons.signUpButton).on('click',
            function () {
                (window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.continue,
                    section: window.HealthyEatingConstants.gtm.event.bank
                }));
            });
        $(window.HealthyEatingConstants.elements.buttons.waitroseCancel).on('click',
            function () {
                (window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.validate,
                    validation: window.HealthyEatingConstants.gtm.event.waitroseModal,
                    validationReason: $(window.HealthyEatingConstants.elements.buttons.modalCancel).val()
                }));
            });
        $(window.HealthyEatingConstants.elements.buttons.waitroseConfirm).on('click',
            function () {
                (window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.validate,
                    validation: window.HealthyEatingConstants.gtm.event.waitroseModal,
                    validationReason: $(window.HealthyEatingConstants.elements.buttons.modalConfirm).val()
                }));
            });
        $(window.HealthyEatingConstants.elements.input.noCard).on('click',
            function () {
                (window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.validate,
                    validation: window.HealthyEatingConstants.gtm.event.loyaltyCard,
                    validationReason: window.HealthyEatingConstants.gtm.event.noCard
                }));
            });
        $(window.HealthyEatingConstants.elements.buttons.delinkButton).on('click',
            function () {
                (window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.delink,
                    action: window.HealthyEatingConstants.gtm.event.delinkAcc,
                    partner: window.HealthyEatingConstants.gtm.event.partnerName
                }));
            });
        $(window.HealthyEatingConstants.elements.buttons.editBankDetailsCTA).on('click',
            function () {
                window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.editDetails,
                    detail: window.HealthyEatingConstants.gtm.event.bank
                });
            });
        $(window.HealthyEatingConstants.elements.buttons.editMembershipNoCTA).on('click',
            function () {
                window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.editDetails,
                    detail: window.HealthyEatingConstants.gtm.event.waitroseId
                });
            });
        $(window.HealthyEatingConstants.elements.buttons.editSurnameCTA).on('click',
            function () {
                window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.editDetails,
                    detail: window.HealthyEatingConstants.gtm.event.surname
                });
            });
        $(window.HealthyEatingConstants.elements.buttons.reviewMembershipNoUpdate).on('click',
            function () {
                window.dataLayer.push({
                    event: window.HealthyEatingConstants.gtm.event.editDetails,
                    detail: window.HealthyEatingConstants.gtm.event.waitroseId,
                    action: window.HealthyEatingConstants.gtm.action.update
                });
            });
    }
});
